/*
* Multilingual language sample
* */
export default {
    en: {
        hello: "hello"
    },
    zh: {
        hello: "你好"
    },
    jp: {
        hello: "こんにちは"
    }
}